import React from 'react';
import { Redirect } from '../../../../Router';
import { routes } from '../../routes';

const RedirectToTimeTracking: React.FC<
  React.PropsWithChildren<unknown>
> = () => <Redirect to={routes.timeTracking.route} />;

export default RedirectToTimeTracking;
